import { AuthClient } from '@/api/auth-client'
import { ActiveCampaignCredentials } from '@/api/model/credentials'

export const ActiveCampaignAPI = new class MailchimpClient extends AuthClient {

    async validateCredentials(activeCampaignCredentials: ActiveCampaignCredentials) {
        const response = await this.client.post(`/api/v1/service/active_campaign/validate_credentials`, {
            apiUrl: activeCampaignCredentials.apiUrl,
            apiKey: activeCampaignCredentials.apiKey,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })

        return response.data.valid
    }

    async activate(activeCampaignCredentials: ActiveCampaignCredentials) {
        const response = await this.client.post(`/api/v1/service/active_campaign/activate`, {
            company: activeCampaignCredentials.company.id,
        }, {
            headers: {
                Accept: 'application/json',
            },
        })
    }

}()
